import { render, staticRenderFns } from "./UiLazyVideo.vue?vue&type=template&id=749ba6e3&scoped=true&"
import script from "./UiLazyVideo.vue?vue&type=script&lang=js&"
export * from "./UiLazyVideo.vue?vue&type=script&lang=js&"
import style0 from "./UiLazyVideo.vue?vue&type=style&index=0&id=749ba6e3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749ba6e3",
  null
  
)

export default component.exports